import { t } from '@lingui/core/macro';

const getExplanationData = () => {
  return [
    t`Book a time and tell us where your car is parked.`,
    t`We’ll come and carry out the service you booked – even if you’re not at home.`,
    t`As soon as we’re done, you’ll get a notification right away!`
  ];
};

export const ExplainMobileTireServiceBooking = () => {
  const relevantInfo = getExplanationData();
  return (
    <div className='flex flex-col gap-4'>
      {relevantInfo.map((item, index) => (
        <div key={index} className='flex gap-2'>
          <b>{index + 1}.</b>
          <span>{item}</span>
        </div>
      ))}
    </div>
  );
};
